import { render } from "./CharitySection.vue?vue&type=template&id=7aa3562a&scoped=true"
import script from "./CharitySection.vue?vue&type=script&lang=js"
export * from "./CharitySection.vue?vue&type=script&lang=js"

import "./CharitySection.vue?vue&type=style&index=0&id=7aa3562a&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7aa3562a"]])

export default __exports__